<div class="tag-shell container">
  <h2>Tag: {{ tag }}</h2>
  <p>Entries filtered by tag will appear here.</p>
</div>
